// The section the owner was last looking at — sent with Assistant turns so "this" / "that one" has a referent.
let last = 'waiting';
export const setLastSection = (s: string): void => { if (s && s !== 'assistant') last = s; };
export const getLastSection = (): string => last;
